import React, { useContext, useEffect, useState, useLayoutEffect } from "react";
import MenuContext from "../../contexts/menu";
import AuthContext from "../../contexts/auth";
import obj from '../../styles/themes/defaulttheme'
import { IoLogOut } from "react-icons/io5";
import MenuItem from "../menuitem";
import aux from "../../utils/auxiliar";
import storage from "../../storage"
import packageInfo from "../../../package.json";
import { CustumerContext } from "../../contexts/custumer";
import { useHistory } from "react-router-dom";
import Options from "../select/options";
import styles from './aside.module.css'
import Title from "../title";
import Subtitle from "../subtitle";
import Text from "../text";

const { name, version } = packageInfo;

type TMenuItens = {
  id: number;
  label: string;
  link: string;
}

interface IProps {
  isActive: boolean;
}

/**
 * 
 * 19334    Rondas
19335    Faturas e Boletos
19336    Ponto
19337    Funcionários
19338    Documentos
19339    Quadro de Vagas
 */

let allMenus = [
  { id: 0, label: 'Home', link: '/', idSar: 0 },
  { id: 2, label: 'Usuários', link: '/usuarios', idSar: 0 },
  { id: 1, label: 'Rondas', link: '/rondas', idSar: 19334 },
  { id: 3, label: 'Faturas e Boletos', link: '/financeiro', idSar: 19335 },
  { id: 4, label: 'Ponto', link: '/ponto', idSar: 19336 },
  { id: 5, label: 'Funcionários', link: '/funcionarios', idSar: 19337 },
  { id: 6, label: 'Documentos', link: '/documentos', idSar: 19338 },
  { id: 7, label: 'Quadro de Vagas', link: '/quadro', idSar: 19339 },
  { id: 8, label: 'Notícias', link: '/noticias', idSar: 0 },
  { id: 9, label: 'Relatórios', link: '/relatorios', idSar: 19529 }
]

const Aside: React.FC = ({ children }) => {
  const { isOpen, currentPage } = useContext(MenuContext);
  const { loggedEmail, isMasterUser, acessos, validaAcessos } = useContext(AuthContext);
  const { signOut } = useContext(AuthContext);
  const { current_custumer_description, selectCurrentCustumer, custumer_list, deleteList } = useContext(CustumerContext)
  const [group, setGroup] = useState<string>("");
  const [logo, setLogo] = useState<string | null>(null);
  const [menuItems, setMenuItems] = useState<TMenuItens[]>([]);
  const history = useHistory();
  const _isMaster = isMasterUser();
  const [showOptions, setShowOptions] = useState<boolean>(false)


  useLayoutEffect(() => {
    buildMenu();
  }, [validaAcessos])


  useEffect(() => {
    const group = storage.getGroupLogged();
    if (group)
      setGroup(group)
    const _logo = storage.getLogoGroupLogged();

    if (_logo && _logo !== "null") {
      setLogo(_logo)
    }
  }, [])


  function buildMenu() {
    if (!validaAcessos) {
      setMenuItems(allMenus);
    } else {
      const aux = allMenus.filter(item =>
        item.idSar === 0 || acessos.includes(item.idSar)
      );

      setMenuItems(aux);
    }
  }


  function logOff() {
    signOut();
    deleteList();
    history.push("/");
  }

  return (
    <>
      {showOptions && <Options close={() => setShowOptions(false)} selectOption={selectCurrentCustumer} itens={custumer_list} sortAlphabetically />}
      <aside className={`w-full h-[100dvh] relative ${styles.container} `} style={{ gridArea: 'aside', backgroundColor: obj.colors.silverBG }}>
        <nav className="w-full h-full bg-gray-800 pt-[12.5px] overflow-y-auto">
          <div className="w-full flex flex-col gap-[10px] pt-[10px] pb-[15px] ">
            <Title className="!w-full !leading-none !font-extrabold !text-[1.0625rem] !text-center !text-[#C3CAD9] ">Portal do Cliente</Title>
            <Subtitle className="!w-full !text-[.75rem] !leading-none  !text-center !text-[#C3CAD9]">{group}</Subtitle>
          </div>
          <div className="mx-[17.5px] h-[.4px] bg-[#757E8E]" />

          <ul className="py-[15px] px-[20px]">
            {menuItems.length > 0 && menuItems.map((item, index) => {
              if (item.id === 2) {
                if (!_isMaster) return null;
              }
              return (
                <li key={index}>
                  <MenuItem
                    label={item.label}
                    link={item.link}
                    Icon={aux.resolveMenuIcon(item.id)}
                    isActive={currentPage === item.link}
                  />
                </li>
              )
            })}
            <div className={`group transition-all w-fit flex items-center p-2.5 hover:bg-gray-500 hover:text-gray-50 mb-[14px] cursor-pointer gap-[14px] rounded-[8px]`} onClick={logOff}>
              <IoLogOut size={19} className="text-[#C3CAD9] " />
              <Text className={`!transition-all !text-nowrap !text-[#828895] group-hover:!text-gray-50    !text-sm !font-medium`}>Sair</Text>
            </div>
          </ul>
        </nav>
        <Text className="!absolute !bottom-5 !left-1/2 !-translate-x-1/2 !text-[.6875rem] !text-[#C3CAD9]">v{version}</Text>
      </aside>
    </>
  )
}

export default Aside;



